/**
 * Cookie setter
 * @param cname {string} - cookie name
 * @param cvalue {string | number} - value stored in the cookie
 * @param exsecs {number} - expiration in seconds
 */
export function setCookie(cname: string, cvalue: string, exsecs: number) {
  const { document, location } = window

  if (document) {
    const d = new Date()
    d.setTime(d.getTime() + exsecs * 1000)
    const expires = `expires=${d.toUTCString()}`
    const protocol = location?.protocol
    const isSecured = protocol === 'https:'

    // Secure condition due to safari browser issue when running app on localhost
    document.cookie = `${cname}=${cvalue};${expires};path=/;${
      isSecured ? 'Secure' : ''
    }`
  }
}
